import {useDispatch, useSelector} from 'react-redux';
import {Settings} from 'redux/actions';

const TOOLS_KEY = {
	paint: 'paint',
	rubber: 'rubber',
	rule: 'rule'
}

const MODE_KEY = {
	select: 'select'
}

const useSettings = () => {
	const dispatch = useDispatch();
	const {tools, mode, selection} = useSelector((state) => state.settings);

	const changeTools = (tools) => {
		//TOOLS_KEY check exist
		dispatch(Settings.changeTools(tools));
	}

	const changeMode = (mode) => {
		//MODE_KEY check exist
		dispatch(Settings.changeMode(mode));
	}

	const resetMode = () => {
		dispatch(Settings.resetMode());
	}

	const saveSelection = (selection) => {
		dispatch(Settings.saveSelection(selection));
	}


	return {
		tools,
		changeTools,
		TOOLS_KEY,
		selection,
		saveSelection,
		resetMode,
		changeMode,
		MODE_KEY,
		mode
	};
};

export default useSettings;
